import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { User } from '@core/models';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
// import * as moment from 'moment-timezone';

@Component({
	selector: 'app-missed-calls',
	templateUrl: './missed-calls.component.html',
	styleUrls: ['./missed-calls.component.scss'],
})
export class MissedCallsComponent implements OnInit {
	constructor(
		private title: Title,
		private dialog: MatDialog,
		public locale: LocaleService,
		private route: ActivatedRoute,
		public viewport: ViewportService,
		private api: ApiService,
		private auth: AuthService,
		private snack: SnackService,
		private clipboard: Clipboard,
		private router: Router
	) {}

	adID: string;
	catID: string;
	loading: boolean = false;
	user: User = this.auth.user();
	missedCalls: any;
	systemTimezone: string;

	getMissedCalls() {
		this.loading = true;
		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('adId', this.adID);

		this.api.getMissedCallsList(body).subscribe((res) => {
			console.log(res);

			if (res['status'] !== '1') {
				this.loading = false;
				this.snack.open(this.locale.translations['misc']['n174']);
			}

			this.missedCalls = res['response'];
			this.loading = false;
		});
	}

	// getSystemTimezone(): string {
	// 	try {
	// 		return moment.tz.guess();
	// 	} catch (err) {
	// 		console.error(err);
	// 		return ''; // Return an empty string or a default timezone if an error occurs
	// 	}
	// }

	//TODO
	onOpenBoostAdDialog() {
		this.router.navigate(['/payment/tier'], {
			queryParams: {
				adID: this.adID,
			},
		});
	}

	copyNumber(phoneNumber) {
		this.clipboard.copy(phoneNumber);
		this.snack.open(this.locale.translations['ads']['ad']['n651']);
	}

	onCall(phoneNumber) {
		const body: FormData = new FormData();
		body.append('lang', this.locale.lang);
		body.append('adId', this.missedCalls['ad']['id']);
		body.append('platform', 'Web');
		body.append('phone', phoneNumber);
		body.append('callType', '0');

		this.api.call(body).subscribe();

		window.location.href = 'tel:' + phoneNumber;
	}

	viewNumber(phoneNumber) {
		//TODO an api call has to be done to view call whose response would come and update then the phone number
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['payment']['n209'] + ' | ' + this.locale.translations['header']['n0']);
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) this.adID = queries['adID'];

			if (queries['catID']) {
				this.catID = queries['catID'];
			}
		});

		// this.systemTimezone = this.getSystemTimezone();

		this.getMissedCalls();
	}
}
